// @flow
import styled from 'styled-components';
import { TableFlexRow } from '../../../components';
import colors from '../../../assets/css/colors';

const isPlayerInSwap = ({ is_in_substitute, is_swap_in_progress, is_player_in_substitute }) => {
	if (!is_swap_in_progress) {
		return false;
	}

	return is_in_substitute && !is_player_in_substitute;
};
const isPlayerNotInSwap = ({ is_in_substitute, is_swap_in_progress, is_player_in_substitute }) => {
	if (is_player_in_substitute) {
		return false;
	}

	return is_swap_in_progress && !is_in_substitute;
};

const getShadow = props => {
	const is_in_swap = isPlayerInSwap(props);
	if (props.is_player_in_substitute) {
		return `inset 0px 0px 0px 2px ${colors.red}`;
	}
	return is_in_swap ? `inset 0px 0px 0px 2px ${colors.green}` : 'none';
};

const getBorderColor = props => {
	const is_in_swap = isPlayerInSwap(props);
	if (props.is_player_in_substitute) {
		return colors.red;
	}
	return is_in_swap ? colors.green : 'transparent';
};

export const TableFlexRowStyled = styled(TableFlexRow)`
	background: ${({ background }) => background || '#fff'};
	cursor: ${props => isPlayerInSwap(props) ? 'pointer': 'default'};
	opacity: ${props => isPlayerNotInSwap(props) ? .5: 1};
	box-shadow: ${props => getShadow(props)};
	position: relative;
	> div:first-child > div:first-child {
		border: 2px solid;
		border-right: 0;
		border-color: ${props => getBorderColor(props)}
	}
	.coach {
		color: ${colors.coachPurple}
	}
`;

export default TableFlexRowStyled;


// WEBPACK FOOTER //
// ./src/pages/league/team/tableFlexRowStyled.js